(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Dispositivo_osDetailController', Dispositivo_osDetailController);

    Dispositivo_osDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Dispositivo_os'];

    function Dispositivo_osDetailController($scope, $rootScope, $stateParams, previousState, entity, Dispositivo_os) {
        var vm = this;

        vm.dispositivo_os = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:dispositivo_osUpdate', function(event, result) {
            vm.dispositivo_os = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
